import type { UserServicePorts } from "../../model";

import type { GetPaginated } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  email,
  phoneNumber,
  userName,
  firstName,
  lastName,
  roles,
  ...rest
}: Extract<
  GetPaginated.Res,
  { status: 200 }
>["body"]["data"]["items"][number]): UserServicePorts.ProviderIos.GetPaginated.Out["items"][number] {
  return {
    ...rest,
    email: email ?? EMPTY,
    phone: phoneNumber ?? EMPTY,
    username: userName ?? EMPTY,
    firstName: firstName ?? EMPTY,
    lastName: lastName ?? EMPTY,
    roles: roles.map(({ id, name, description }) => ({
      id,
      name: name ?? EMPTY,
      description: description ?? EMPTY,
    })),
  };
}

export { mapDtoToEntity };
